import { tv } from 'tailwind-variants';

import type { Site } from '@/api/fe-api/domain/entities/site';
import { SiteOperationalPhase } from '@/api/fe-api/domain/entities/site-operational-phase';

const colorPerPhase: Record<SiteOperationalPhase, 'yellow' | 'green' | 'gray'> =
  {
    [SiteOperationalPhase.PLANNING]: 'yellow',
    [SiteOperationalPhase.COMMISSIONING]: 'yellow',
    [SiteOperationalPhase.IN_OPERATION]: 'green',
    [SiteOperationalPhase.MONITORING_ENDED]: 'gray',
    [SiteOperationalPhase.END_OF_LIFE]: 'gray',
  };

export type OperationalPhaseProps = {
  site: Site;
  className?: string;
  variant?: 'default' | 'text';
};

export function OperationalPhase({
  site,
  variant = 'default',
  className,
}: OperationalPhaseProps) {
  const style = sitePhasesStyle({
    color: colorPerPhase[site.operationalPhase],
    variant,
  });

  return (
    <div className={style.container({ className })}>
      {site.operationalPhase}
    </div>
  );
}

const sitePhasesStyle = tv({
  slots: {
    container: `
      rounded-full
      border
      px-4
      py-1
    `,
  },
  variants: {
    color: {
      yellow: {
        container: 'bg-yellow-100 text-yellow-500',
      },
      green: {
        container: 'bg-green-100 text-green-600',
      },
      gray: {
        container: 'bg-neutral-100 text-neutral-500',
      },
    },
    variant: {
      default: {},
      text: {
        container: 'border-none bg-transparent p-0',
      },
    },
  },
});
